export default function getStatic(path) {
  if (typeof process.env.STATIC_ASSET_PATH !== 'undefined') {
    return `${process.env.STATIC_ASSET_PATH}${path}`;
  }

  return path;
}
